<template>
  <div>
    <div class="container">
      <div class="navbar">
        <div class="logo">
          <img src="@/assets/images/logo.svg" />
        </div>
        <div class="logoutbtn">
          <div class="logout" v-on:click="logout">Logout</div>
          <div class="pizzahut">
            <img style="border-radius: 50%;width: 35px;" :src="$root.user.discord.avatar ? `https://cdn.discordapp.com/avatars/${$root.user.discord.id}/${$root.user.discord.avatar}.png`: `https://cdn.discordapp.com/embed/avatars/0.png`" />
          </div>
        </div>
      </div>
      <div class="cardrow">
        <div class="card2" id="card1">
          <div class="cardGrid">
            <img class="pizzakhabo" style="border-radius: 50%;" :src="$root.user.discord.avatar ? `https://cdn.discordapp.com/avatars/${$root.user.discord.id}/${$root.user.discord.avatar}.png`: `https://cdn.discordapp.com/embed/avatars/0.png`" />
            <div class="name">{{ $root.user.discord.username }}</div>
            <div class="expiry">
              <span> Member Since </span>
              {{ (new Date($root.user.subscription.createdAt)).toLocaleDateString() }}
            </div>
          </div>
          <div class="box">
            <!--<progress-bar type="circle" ref="line" class="progress" :options="barOptions">
            </progress-bar>-->
          </div>
        </div>
        <div class="card2">
          <div class="text">
            <div class="rewards">Rewards</div>
            <!--<div class="btns">
              <button>
                <img src="@/assets/images/left.svg" />
              </button>
              <button>
                <img src="@/assets/images/right.svg" />
              </button>
            </div>-->
          </div>
          <div class="smolRow">
            <p style="margin: 0 auto;" v-if="rewards.length == 0">No wins yet</p>
            <div class="smol" v-for="reward in rewards" :key="reward.name">
              <div class="img">
                <img :src="reward.image + '?wid=500&hei=500&fmt=png-alpha'" style="width:130px" />
              </div>
              <div class="jordan">{{ reward.name }}</div>
              <!--<div class="redeem">
                Redeem
                <img src="@/assets/images/blueRight.svg" />
              </div>-->
            </div>
          </div>
        </div>
      </div>
      <div v-if="success" style="background: #19b719;width: 97.3%;padding: 20.5px;margin-bottom: 20px;margin-top: 30px;margin-left: 0px;position: relative;">{{ successMessage }}</div>
      <div v-if="error" style="background: #c31818;width: 97.3%;padding: 20.5px;margin-bottom: 20px;margin-top: 30px;margin-left: 0px;position: relative;">{{ errorMessage }}</div>
      <div class="grid">
        <div class="grid_elem1" id="gridelem">
          <div class="Gridrow" id="row1">
            <div class="GridText">
              <div class="heading">Discord Account</div>
              <div class="content">{{ $root.user.discord.username }}</div>
            </div>
            <div class="Gridbuttons">
              <span class="unbind" v-on:click="unbind">Unbind</span>
              <span class="join" v-on:click="joinDiscord">Join Server</span>
            </div>
          </div>
          <div class="Gridrow" id="row2">
            <div class="GridText">
              <div class="heading">License Key</div>
              <div class="content">{{ $root.user.subscription.licenseKey }}</div>
            </div>
            <div class="Gridbuttons">
              <span class="manage" v-on:click="showModal">Manage</span>
              <!--span class="extend" v-on:click="showModal">Extend</span-->
            </div>
          </div>
          <div class="Gridrow" id="row3">
            <div class="GridText">
              <div class="heading">Renewal Date</div>
              <div class="content">{{ (new Date($root.user.subscription.periodEnd * 1000)).toLocaleDateString() }}</div>
            </div>
            <div class="Gridbuttons">
              <span class="edit" v-on:click="manage">Edit</span>
            </div>
          </div>
          <div class="Gridrow" id="row4">
            <div class="GridText">
              <div class="heading">Address</div>
              <div class="content" v-html="$root.user.subscription.addressFormat1"></div>
            </div>
            <div class="Gridbuttons">
              <span class="edit" v-on:click="manage">View</span>
            </div>
          </div>
        </div>
        <div class="grid_elem2" id="gridelem">
          <div class="CreditCard">
            <div class="card_details">
              <div class="Cardname" v-html="$root.user.subscription.cardName"></div>
              <div class="address">
                <!--<div class="add">123 Snkrs In</div>
                <div class="add">New York,NY</div>-->

                <div v-html="$root.user.subscription.addressFormat2" />
              </div>
            </div>
            <div class="date">
              <span>valid through</span><br />
              {{ $root.user.subscription.cardExpire }}
            </div>
            <div class="number">
              <img src="@/assets/images/dots.svg" />
              <img src="@/assets/images/dots.svg" />
              <img src="@/assets/images/dots.svg" />
              {{ $root.user.subscription.cardLast4 }}
            </div>
          </div>
          <div class="update" v-on:click="manage">
            Update Payment Method
          </div>
        </div>
      </div>
    </div>

    <div v-if="modalShowed" class="modal" style="display:unset;">
      <div class="modal-content">
        <div class="modal-body">
          <div class="email leftemail">
            <img src="@/assets/images/email.svg" />
            <div class="heading">Change Email</div>
            <div class="formm">
              <label>New Email</label>
              <input type="text" v-model="email" placeholder="Enter Email" />
            </div>
            <div class="extend-btn" v-on:click="changeEmail">Change</div>
          </div>
          <div class="email rightemail">
            <img src="@/assets/images/licesnse1.svg" />
            <div class="heading">Resend License</div>
            <div class="Licesnetext">
              Resend your license key to your updated email.
            </div>
            <div class="extend-btn" v-on:click="resendKey">Resend</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js'

export default {
  name: 'Dashboard',
  data () {
    return {
      barOptions: {
        color: "#fff",
        strokeWidth: 5,
        duration: 2000, // milliseconds
        easing: "easeInOut",
        trailColor: "rgba(255, 255, 255, 0.25)"
      },
      submitting: false,
      error: false,
      errorMessage: '',
      success: false,
      successMessage: '',
      modalShowed: false,
      email: '',
      rewards: []
    }
  },
  methods: {
    showModal () {
      this.modalShowed = !this.modalShowed
    },
    unbind (e) {
      e.preventDefault()

      if (this.submitting) return

      this.error = false
      this.errorMessage = ''
      this.success = false
      this.successMessage = ''
      this.submitting = true

      fetch(`/api/v1/user/unbind`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include'
      }).then(res => {
        this.submitting = false

        if (res.status == 200) {
          location.href = '/bind'
        } else {
          this.errorMessage = 'An unexpected error occurred, please try again later'
          this.error = true
        }
      }).catch(() => {
        this.submitting = false
        this.errorMessage = 'An unexpected error occurred, please try again later'
        this.error = true
      })
    },
    changeEmail (e) {
      e.preventDefault()

      if (this.submitting) return

      this.error = false
      this.errorMessage = ''
      this.success = false
      this.successMessage = ''
      this.submitting = true

      fetch(`/api/v1/user/changeEmail`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ email: this.email }),
      }).then(async res => {
        this.showModal()
        this.submitting = false

        if (res.status == 200) {
          this.successMessage = 'Email has been successfully changed!'
          this.success = true
        } else {
          this.errorMessage = 'An unexpected error occurred, please try again later'
          this.error = true
        }
      }).catch(() => {
        this.showModal()
        this.submitting = false
        this.errorMessage = 'An unexpected error occurred, please try again later'
        this.error = true
      })
    },
    resendKey (e) {
      e.preventDefault()

      if (this.submitting) return

      this.error = false
      this.errorMessage = ''
      this.success = false
      this.successMessage = ''
      this.submitting = true

      fetch(`/api/v1/user/resendKey`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include'
      }).then(async res => {
        this.showModal()
        this.submitting = false

        if (res.status == 200) {
          this.successMessage = 'Key has been successfully sent to your email!'
          this.success = true
        } else {
          this.errorMessage = 'An unexpected error occurred, please try again later'
          this.error = true
        }
      }).catch(() => {
        this.showModal()
        this.submitting = false
        this.errorMessage = 'An unexpected error occurred, please try again later'
        this.error = true
      })
    },
    manage (e) {
      e.preventDefault()

      if (this.submitting) return

      this.error = false
      this.errorMessage = ''
      this.success = false
      this.successMessage = ''
      this.submitting = true

      fetch(`/api/v1/user/manage`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include'
      }).then(async res => {
        this.submitting = false

        if (res.status == 200) {
          let data = await res.json()
          location.href = data.portalUrl
        } else {
          this.errorMessage = 'An unexpected error occurred, please try again later'
          this.error = true
        }
      }).catch(() => {
        this.submitting = false
        this.errorMessage = 'An unexpected error occurred, please try again later'
        this.error = true
      })
    },
    joinDiscord (e) {
      e.preventDefault()

      if (this.submitting) return

      this.error = false
      this.errorMessage = ''
      this.success = false
      this.successMessage = ''
      this.submitting = true

      fetch(`/api/v1/user/joinDiscord`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include'
      }).then(async res => {
        this.submitting = false

        if (res.status == 200) {
          this.successMessage = 'Successfully joined server!'
          this.success = true
        } else {
          this.errorMessage = 'An unexpected error occurred, please try again later'
          this.error = true
        }
      }).catch(() => {
        this.submitting = false
        this.errorMessage = 'An unexpected error occurred, please try again later'
        this.error = true
      })
    },
    logout() {
      fetch(`/api/v1/user/logout`, {
        credentials: 'include'
      }).then(res => res.json()).then(async () => {
        location.href = '/login'
      }).catch(err => {
        console.log(err)
      })
    }
  },
  mounted () {
    this.rewards = this.$root.user.rewards.slice((this.$root.user.rewards.length - 3), this.$root.user.rewards.length)
    /*this.rewards = [{
      name: "Air Jordan 1 Low 'Travis Scott x Fragment",
      image: 'https://images.nike.com/is/image/DotCom/PDP_HERO/JORDAN-DM7866_140_E_PREM.jpg?wid=2000&hei=2000&fmt=png-alpha'
    }]
    /*this.$refs.line.animate(0.63)
    this.$refs.line.setText(`<div class="inner">
      <img class="Gem" src="/levels/gem.svg" style="padding-left:25%" />
      <div class="circletext">
        Lvl 2
      </div>
      <div class="circletext" id="secondcircletext">
        20 more points
      </div>
    </div>`)*/
  },
  created () {
    fetch(`/api/v1/release/getData`, {
      credentials: 'include'
    }).then(res => res.json()).then(async res => {
      this.stripe = await loadStripe(res.publicKey)
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>

<style>
  @import '../../../assets/css/dashboard.css';
</style>
